import { put, takeLatest } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";
import {
  getAllFormTemplatesSuccess,
  getAllFormTemplatesFailure,
  getFormTemplateDetailsSuccess,
  getFormTemplateDetailsFailure,
  getFormTemplateDocumentSuccess,
  getFormTemplateDocumentFailure,
  getFormSectionsSuccess,
  getFormSectionsFailure,
  getDefinedNamesSuccess,
  getDefinedNamesFailure,
  getFormTemplateListSuccess,
  getFormTemplateListFailure,
  getPhotoLayoutsSuccess,
  getPhotoLayoutsFailure,
} from "./slice";
import { FORM_TEMPLATES_REQUEST } from "./types";
import { axiosInstance } from "../../utils/AxiosInstance";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function* getAllFormTemplates(action: any) {
  const params = {
    ...action.payload,
  };
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates`,
      {
        params,
        paramsSerializer: {
          indexes: null,
        },
      }
    );
    yield put(getAllFormTemplatesSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getAllFormTemplatesFailure({ error: err.response?.data }));
  }
}

function* getFormTemplateDetails(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates/${id}`
    );
    yield put(getFormTemplateDetailsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormTemplateDetailsFailure({ error: err.response?.data }));
  }
}

function* getFormTemplateDocument(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates/${id}/document`
    );
    yield put(getFormTemplateDocumentSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormTemplateDocumentFailure({ error: err.response?.data }));
  }
}

function* getFormSections(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates/${id}/sections`
    );
    yield put(getFormSectionsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormSectionsFailure({ error: err.response?.data }));
  }
}

function* getDefinedNames(action: any) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates/${id}/defined-names`
    );
    yield put(getDefinedNamesSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getDefinedNamesFailure({ error: err.response?.data }));
  }
}

function* getFormTemplateList() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/formtemplates/list`
    );
    yield put(getFormTemplateListSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getFormTemplateListFailure({ error: err.response?.data }));
  }
}

function* getPhotoLayouts() {
  try {
    const response: AxiosResponse<any> = yield axiosInstance.get(
      `${API_BASE_URL}/api/v1/photolayouts`
    );
    yield put(getPhotoLayoutsSuccess({ response: response?.data }));
  } catch (error) {
    const err = error as AxiosError;
    yield put(getPhotoLayoutsFailure({ error: err.response?.data }));
  }
}

export function* formTemplatesSaga() {
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getAllFormTemplatesRequest`,
    getAllFormTemplates
  );
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getFormTemplateDetailsRequest`,
    getFormTemplateDetails
  );
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getFormTemplateDocumentRequest`,
    getFormTemplateDocument
  );
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getFormSectionsRequest`,
    getFormSections
  );
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getDefinedNamesRequest`,
    getDefinedNames
  );
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getFormTemplateListRequest`,
    getFormTemplateList
  );
  yield takeLatest(
    `${FORM_TEMPLATES_REQUEST}/getPhotoLayoutsRequest`,
    getPhotoLayouts
  );
}
